import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getUserStats, getReviewCount, updateStreak, UserStats } from '../services/api';
import './Home.css';

const Home: React.FC = () => {
  const [stats, setStats] = useState<UserStats | null>(null);
  const [reviewCount, setReviewCount] = useState(0);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [statsData, reviewData, streakData] = await Promise.all([
          getUserStats(),
          getReviewCount(),
          updateStreak()
        ]);
        setStats(statsData);
        setReviewCount(reviewData.dueCount);
      } catch (err) {
        console.error('Failed to load data:', err);
      }
    };
    loadData();
  }, []);

  return (
    <div className="home fade-in">
      <div className="welcome-section">
        <h1>Cześć! 👋</h1>
        <p>Gotowy na naukę angielskiego?</p>
      </div>

      <div className="stats-row">
        <div className="stat-card points">
          <span className="stat-icon">⭐</span>
          <span className="stat-value">{stats?.totalPoints || 0}</span>
          <span className="stat-label">punktów</span>
        </div>
        <div className="stat-card streak">
          <span className="stat-icon">🔥</span>
          <span className="stat-value">{stats?.currentStreak || 0}</span>
          <span className="stat-label">dni z rzędu</span>
        </div>
        <div className="stat-card words">
          <span className="stat-icon">📖</span>
          <span className="stat-value">{stats?.wordsLearned || 0}</span>
          <span className="stat-label">słówek</span>
        </div>
      </div>

      <div className="quick-actions">
        <Link to="/lessons" className="action-card lessons">
          <span className="action-icon">📚</span>
          <span className="action-title">Lekcje</span>
          <span className="action-desc">Ucz się nowych słówek</span>
        </Link>

        <Link to="/games" className="action-card games">
          <span className="action-icon">🎮</span>
          <span className="action-title">Gry</span>
          <span className="action-desc">Sprawdź swoją wiedzę</span>
        </Link>

        <Link to="/review" className="action-card review">
          <span className="action-icon">🔄</span>
          <span className="action-title">Powtórka</span>
          <span className="action-desc">
            {reviewCount > 0 ? `${reviewCount} słówek do powtórki` : 'Brak powtórek'}
          </span>
          {reviewCount > 0 && <span className="review-badge">{reviewCount}</span>}
        </Link>

        <Link to="/custom-sets" className="action-card custom-sets">
          <span className="action-icon">📝</span>
          <span className="action-title">Moje zestawy</span>
          <span className="action-desc">Własne zestawy słówek</span>
        </Link>

        <Link to="/dictionary" className="action-card dictionary">
          <span className="action-icon">📖</span>
          <span className="action-title">Słownik</span>
          <span className="action-desc">Przeglądaj poznane słówka</span>
        </Link>
      </div>

      <div className="today-stats card">
        <h3>📅 Dzisiaj</h3>
        <p>Zdobyłeś <strong>{stats?.todayPoints || 0}</strong> punktów</p>
        <p>Ukończone lekcje: <strong>{stats?.lessonsCompleted || 0}</strong></p>
      </div>
    </div>
  );
};

export default Home;

